<template>
<div style="height: 100vh;" class="blue lighten-2">
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md5>
        <v-card class="grey lighten-4">
          <v-container>
            <v-layout column align-center>
              <v-flex>
                <img
                  class="logo"
                  src="@/assets/ble.jpg"
                  alt="BLE Tracker Logo"
                />
              </v-flex>
              <v-flex xs12 my-3>
                <h1>Bluetooth Site Board</h1>
              </v-flex>
              <v-form v-model="valid" @submit.prevent="login" @keyup.native.enter="login">
                <v-flex xs12>
                  <v-text-field
                    label="Email"
                    :rules="emailRules"
                    v-model="email"
                    outline
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Password"
                    v-model="password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :rules="passwordRules"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    outline
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-btn :disabled="!valid" @click="login" block color="info">Login</v-btn>
                </v-flex>
              </v-form>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      color="red"
      >
      {{errorText}}
    </v-snackbar>
  </v-container>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  data () {
    return {
      email: '',
      password: '',
      showPassword: false,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required'
      ],
      errorText: '',
      snackbar: false
    }
  },
  methods: {
    login () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(user => {
        console.log(user);
        this.$router.push('/main');
      })
    },
    submit () {
      if (this.email === 'j@test.com' && this.password === '123456') {
        this.$router.push('main')
        console.log('Login correct')
      } else {
        this.snackbar = true
        this.errorText = 'Incorect details'
        this.password = ''
      }
    }
  }
}
</script>

<style>
.logo {
  width: 15vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue